/**
 * 表格组件
 * 遵循 Opinion 表格开发规范
 */
import React, { useMemo } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import type { TRequestBackType } from '@op/utils/requestUtil';
import { DBO_V } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage';

interface ITableChartProps {
  data?: TRequestBackType;
  getDisplayName: (name: string) => string;
}

const TableChart: React.FC<ITableChartProps> = ({ data, getDisplayName }) => {
  const { formatMessage } = useLanguage();
  // 表格列配置
  const { columns, sortColumns } = useMemo(() => {
    const cols: any[] = [
      {
        key: 'date',
        header: formatMessage({ id: 'Date' }),
        width: 120,
      },
    ];
    const keys = ['date'];

    // 添加每个系列的列
    data?.series?.forEach((item) => {
      cols.push({
        key: item.name,
        header: getDisplayName(item.name),
        align: 'right',
        render: (record: any) => DBO_V.reviews(record[item.name] || 0),
        width: 120
      });
      keys.push(item.name);
    });

    // 添加总计列
    cols.push({
      key: 'total',
      align: 'right',
      header: formatMessage({ id: 'Total' }),
      render: (record: any) => DBO_V.reviews(record.total || 0),
      width: 120
    });
    return { columns: cols, sortColumns: keys };
  }, [data, getDisplayName, formatMessage]);

  // 表格数据
  const records = useMemo(() => {
    if (data?.isEmpty) return [];

    return data?.tableRecord || [];
  }, [data]);

  return (
    <TableCommonHook
      className="dbo-dimension-trend__table"
      recordKey="date"
      columns={columns}
      records={records}
      hasPageable={false}
      maxHeight={292}
      minWidth={700}
      sortType="local"
      // sortColumns={sortColumns}
      defaultSort={{ by: 'date', order: 'desc' }}
    />
  );
};

export default TableChart;
